<template>
	<v-container fluid>
	  <v-row class="mt-6 mr-2 ml-2">
	  	<v-col class="py-1" cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-text>
					  <v-data-table
					    :headers="headers"
					    :items="desserts"
					    class="elevation-0"
					    :loading="cargar"
					  >
					  	<template v-slot:item.estadoCA="{ item }">
					      <v-chip color="grey" dark v-if="item.estadoCA == 'A'" small>Abierto</v-chip>
					      <v-chip color="green" dark v-if="item.estadoCA == 'B'" small>Cerrado</v-chip>
					    </template>

					    <template v-slot:item.disposicion="{ item }">
					      <v-chip color="grey" dark v-if="item.correcion              == 'si'" small>Correción</v-chip>
					      <v-chip color="grey" dark v-if="item.reproceso              == 'si'" small>Reproceso</v-chip>
					      <v-chip color="grey" dark v-if="item.rechazo                == 'si'" small>Rechazo</v-chip>
					      <v-chip color="grey" dark v-if="item.aceptadoBajoConcesion  == 'si'" small>Aceptado Bajo concensión</v-chip>
					    </template>

					    <template v-slot:top>
					      <v-toolbar flat >
					        <v-toolbar-title class="text-headline">
					        	Formatos
					        </v-toolbar-title>
					        <v-spacer></v-spacer>

									<v-menu   bottom origin="center center" transition="scale-transition"	>

										<template v-slot:activator="{ on, attrs }">
											<v-btn color="red" dark v-bind="attrs" tile small	v-on="on" class="mb-2 mr-2"> Agregar </v-btn>
										</template>

										<v-list link> 
											<v-list-item 
												v-for="(item, index) in opciones_agregar"	
												:key="index" link
												@click="item.id === 1 ? formatoModal = true: formularioModal = true"
											>
												<v-list-item-title >{{ item.title }}</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>

					        <v-dialog
					        	style="border-radius: 0px;"
					          v-model="formatoModal"
					          max-width="800"
					        >
					          <template v-slot:activator="{ on, attrs }">
					            <v-btn
					              color="red"
					              dark
					              class="mb-2"
					              v-bind="attrs"
					              v-on="on"
					              small
					              rounded
					              @click="estadoCA = 'A'"
					            >
					              Nuevo formato
					            </v-btn>
					          </template>
					          <v-card>
					          	<v-btn
					          		class="mt-2"
							          color="blue darken-2"
							          dark
							          fab
							          floating
							          absolute
							          right
							          @click="abrirDialogFormato()"
							        >
							          <v-icon >
							            mdi-file
							          </v-icon>
							        </v-btn>
					            <v-card-title>
					              <span class="text-h5">{{ formTitle }}</span>
					            </v-card-title>

					            <v-card-text>
					              <v-container>
					              	<v-row>
					              		<div>REPORTE DE NO CONFORMIDAD/ACCIÓN CORRECTIVA</div>
					              	</v-row>
					              	<v-row>
					              		<v-col class="py-0" cols="12">
							              	<v-text-field
							              	  outlined
							              	  dense
							              	  label="Responsable"
							              	  v-model="responsable"
							              	  :readonly="readonlyAdmin"
							              	></v-text-field>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6" lg="4">
							              	<v-text-field
							              		hide-details
							              	  outlined
							              	  dense
							              	  label="# de reporte"
							              	  v-model="noReporte"
							              	  :readonly="readonlyAdmin"
							              	></v-text-field>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6" lg="4">
							              	<v-text-field
							              		hide-details
							              	  outlined
							              	  dense
							              	  label="Fecha"
							              	  v-model="fecha"
							              	  type="date"
							              	  :readonly="readonlyAdmin"
							              	></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 2 -->
					              	<v-row class="mt-12">
					              		<div>FUENTES DE INFORMACIÓN</div>
					              	</v-row>

					              	<v-row>
					              		<v-col class="py-0" cols="12" md="4" lg="3">
						              		<v-checkbox
						              			hide-details
													      v-model="servicioNoConforme"
													      label="Servicio No Conforme"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
					              		</v-col>

												    <v-col class="py-0" cols="12" md="4" lg="3">
						              		<v-checkbox
						              			hide-details
													      v-model="auditoriaCalidad"
													      label="Auditoria de Calidad"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="4" lg="3">
						              		<v-checkbox
						              			hide-details
													      v-model="quejaCliente"
													      label="Queja del Cliente"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="4" lg="3">
						              		<v-checkbox
						              			hide-details
													      v-model="satisfaccionCliente"
													      label="Satisfacción del Cliente"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="4" lg="3">
						              		<v-checkbox
						              			hide-details
													      v-model="sistemaAdministracionCalidad"
													      label="Sistema de Administración de Calidad"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
					              		</v-col>
					              	</v-row>

					              	<v-row>
					              		<v-col cols="12">
					              			<v-radio-group
													      v-model="fuenteInformacion"
													      row
													      :readonly="readonlyAdmin"
													    >
													      <v-radio
													        label="Interna"
													        value="Interna"
													      ></v-radio>
													      <v-radio
													        label="Externa"
													        value="Externa"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 3 -->
					              	<v-textarea
					              		label="Descripción de la No-Conformidad"
					              		outlined
					              		dense
					              		rows="3"
					              		v-model="descripConformidad"
					              		:readonly="readonlyAdmin"
					              	></v-textarea>

					              	<!-- Sección 3 -->
					              	<v-row class="mt-6">
					              		<div>Dispocición:           Acción inmedita consiste en:</div>
					              	</v-row>

					              	<v-row>
					              		<v-col class="py-0" cols="12" md="6">
						              		<v-checkbox
						              			hide-details
													      v-model="correcion"
													      label="Corrección"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
													    <span>(Enfocado al SAC y al servicio/Producto)</span>
													    <v-textarea
							              		label="Descripción"
							              		outlined
							              		dense
							              		v-model="descripcorrecion"
							              		:readonly="readonlyAdmin"
							              	></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
						              		<v-checkbox
						              			hide-details
													      v-model="reproceso"
													      label="Reproceso"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
													    <span>(Enfocado al servicio/producto)</span>
													    <v-textarea
							              		label="Descripción"
							              		outlined
							              		dense
							              		v-model="descripreproceso"
							              		:readonly="readonlyAdmin"
							              	></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
						              		<v-checkbox
						              			hide-details
													      v-model="rechazo"
													      label="Rechazo"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
													    <span>(Enfocado al servicio/producto)</span>
													    <v-textarea
							              		label="Descripción"
							              		outlined
							              		dense
							              		v-model="descriprechazo"
							              		:readonly="readonlyAdmin"
							              	></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
						              		<v-checkbox
						              			hide-details
													      v-model="aceptadoBajoConcesion"
													      label="Aceptado bajo concesión"
													      value="si"
													      :readonly="readonlyAdmin"
													    ></v-checkbox>
													    <span>(Enfocado al servicio/producto)</span>
													    <v-textarea
							              		label="Descripción"
							              		outlined
							              		dense
							              		v-model="descripaceptadoBajoConcesion"
							              		:readonly="readonlyAdmin"
							              	></v-textarea>
					              		</v-col>
				              		</v-row>


				              		<!-- Sección 4 -->
					              	<v-row>
					              		<div>Evaluacipón para la aplicación de una Acción Correctiva</div>
					              	</v-row>

					              	<v-row>
					              		<v-col class="py-0" cols="12">
					              			<v-textarea
							              		label="Conclusión de la evaluación"
							              		outlined
							              		dense
							              		v-model="conclusionEvaluacion"
							              		:readonly="readonlyAdmin"
							              	></v-textarea>
					              		</v-col>
					              		<v-col class="py-0" cols="12">
					              			<div>Se requiere la acción correctiva</div>
					              			<v-radio-group
													      v-model="seccioncuatro"
													      row
													      :readonly="readonlyAdmin"
													    >
													      <v-radio
													        label="Sí"
													        value="si"
													      ></v-radio>
													      <v-radio
													        label="No"
													        value="no"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 5 -->
					              	<v-row>
					              		<div>METODOLOGÍA: Análisis de Diagrama de causa y Efecto</div>
					              	</v-row>

					              	<v-row>
					              		<v-col class="py-0" cols="12" md="6">
					              			<v-text-field
					              			  type="date"
					              			  label="Fecha"
					              			  v-model="fechaMetodologia"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<v-row>
					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Mano de obra"
					              			  v-model="manoObra"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Método"
					              			  v-model="metodo"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Maq, y equipo"
					              			  v-model="masYEquipo"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Materiales"
					              			  v-model="materiales"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Medio ambiente"
					              			  v-model="medioAmbiente"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>
					              	</v-row>


					              	<v-row>
					              		<div>Participantes</div>
					              	</v-row>
					              	<v-row>
					              		<v-col class="py-1" cols="12">
					              			<v-text-field
					              				hide-details
					              			  label="Participante 1"
					              			  v-model="participante1"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="12">
					              			<v-text-field
					              				hide-details
					              			  label="Participante 2"
					              			  v-model="participante2"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="12">
					              			<v-text-field
					              				hide-details
					              			  label="Participante 3"
					              			  v-model="participante3"
					              			  outlined
					              			  :readonly="readonlyAdmin"
					              			  dense
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 6 -->
					              	<v-row class="mt-6">
					              		<div>Descripción de la Causa Raíz</div>
					              	</v-row>
					              	<v-row>
				              			<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Descripción de la Causa Raíz"
					              			  v-model="descripCausaRaiz"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-textarea
					              			  label="Acción correctiva"
					              			  v-model="accionCorrectiva"
					              			  outlined
					              			  dense
					              			  rows="3"
					              			  :readonly="readonlyAdmin"
					              			></v-textarea>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 7 -->
					              	<v-row class="mt-6">
				              			<v-col class="py-0" cols="12" md="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha de compromiso"
					              			  v-model="fechaCompromiso"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-0" cols="12" md="6">
					              			<v-text-field
					              				hide-details
					              			  label="Auditor de calidad"
					              			  v-model="auditorCalidad"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 8 -->
					              	<v-row class="mt-10">
					              		<div>Seguimiento de acción correctiva y revisión de su implementación</div>
					              	</v-row>
					              	<v-row>
				              			<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="number"
					              			  label="%"
					              			  v-model="seguimiento1por"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha"
					              			  v-model="seguimiento1Fecha"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<v-row>
				              			<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="number"
					              			  label="%"
					              			  v-model="seguimiento2por"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha"
					              			  v-model="seguimiento2Fecha"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<v-row>
				              			<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="number"
					              			  label="%"
					              			  v-model="seguimiento3por"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha"
					              			  v-model="seguimiento3Fecha"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<v-row>
				              			<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="number"
					              			  label="%"
					              			  v-model="seguimiento4por"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>

					              		<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha"
					              			  v-model="seguimiento4Fecha"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<v-row>
				              			<v-col class="py-1" cols="6">
					              			<v-text-field
					              				hide-details
					              			  type="date"
					              			  label="Fecha de Cumplimiento"
					              			  v-model="fechaCumplimientoRevision"
					              			  outlined
					              			  dense
					              			  :readonly="readonlyAdmin"
					              			></v-text-field>
					              		</v-col>
					              	</v-row>

					              	<!-- Sección 8 -->
					              	<v-row class="mt-10" align="center">
					              		<div>Verificación de la efectividad</div>
					              	</v-row>

					              	<v-row>
					              		<v-col cols="12" class="pb-0">
					              			¿Acción correctiva efectiva?
					              		</v-col>
					              		<v-col cols="12" class="pb-0">
					              			<v-radio-group
					              				:readonly="readonly"
													      v-model="veriAccionCorrectiva"
													      row
													      hide-details
													    >
													      <v-radio
													        label="Si"
													        value="si"
													      ></v-radio>
													      <v-radio
													        label="No"
													        value="no"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>

					              		<v-col cols="12">
					              			<v-textarea
					              				:readonly="readonly"
					              				v-model="veriEvidenciaObjetiva"
					              				outlined
					              				dense
					              				hide-details
					              				rows="3"
					              				label="Evidencia objetiva de la efectividad"
					              			></v-textarea>
					              		</v-col>

					              		<v-col cols="12">
					              			<v-text-field
					              				:readonly="readonly"
					              				v-model="veriFecha"
					              				outlined
					              				type="date"
					              				dense
					              				label="Fecha"
					              				hide-details
					              			></v-text-field>
					              		</v-col>

					              		<v-col cols="12" class="pb-0">
					              			¿Se requiere algún cambio en los procedimientos?
					              		</v-col>
					              		<v-col cols="12" class="py-0">
					              			<v-radio-group
					              				:readonly="readonly"
													      v-model="veriRquiereCambio"
													      row
													    >
													      <v-radio
													        label="Si"
													        value="si"
													      ></v-radio>
													      <v-radio
													        label="No"
													        value="no"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>

					              		<v-col cols="12" class="pb-0">
					              			¿Se requiere la Re-valuación de los riesgos y oportunidades?
					              		</v-col>
					              		<v-col cols="12" class="py-0">
					              			<v-radio-group
					              				:readonly="readonly"
													      v-model="veriRevaluacion"
													      row
													    >
													      <v-radio
													        label="Si"
													        value="si"
													      ></v-radio>
													      <v-radio
													        label="No"
													        value="no"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>

					              		<v-col cols="12" class="pb-0">
					              			<v-text-field
					              				:readonly="readonly"
					              				v-model="veriAuditor"
					              				outlined
					              				dense
					              				hide-details
					              				label="Auditor Responsable"
					              			></v-text-field>
					              		</v-col>

					              		<v-col cols="12" class="pb-0">
					              			Cierre de autoria
					              		</v-col>
					              		<v-col cols="12" class="py-0">
					              			<v-radio-group
					              				:readonly="readonly"
													      v-model="cierreAuditoria"
													      row
													      hide-details
													    >
													      <v-radio
													        label="Si"
													        value="si"
													      ></v-radio>
													      <v-radio
													        label="No"
													        value="no"
													      ></v-radio>
													    </v-radio-group>
					              		</v-col>
					              	</v-row>

					              </v-container>
					            </v-card-text>

					            <v-card-actions>
					              <v-spacer></v-spacer>
					              <v-btn
					                color="primary"
					                rounded
					                small
					                @click="close"
					              >
					                Cancelar
					              </v-btn>
					              <v-btn
					                color="red"
					                rounded
					                small
					                @click="save"
					                dark
					              >
					                Guardar
					              </v-btn>
					            </v-card-actions>
					          </v-card>
					        </v-dialog>

									<v-dialog v-model="formularioModal" width="800" persistent>
										<v-card class="pa-4 ">
											<v-card-actions class="pa-0">
												<v-card-text class="font-weight-black  text-h6"> NUEVO FORMULARIO</v-card-text>
												<v-btn color="error" text @click="formularioModal = false"> <v-icon large>mdi-close</v-icon> </v-btn>
											</v-card-actions>

											<v-row justify="start" class="pa-4 py-0" >
												<v-col cols="12" sm="6" >
													<v-text-field v-model="formulario[0].noReporte" outlined dense hide-details label="Número de reporte"></v-text-field>
												</v-col>
												<v-col cols="12" sm="6">
													<v-text-field v-model="formulario[0].fuenteInformacion" outlined dense hide-details label="Fuente de la no conformidad"></v-text-field>
												</v-col>
												<v-col cols="12" sm="6" >
													<v-text-field v-model="formulario[0].responsable" outlined dense hide-details label="Area - Respondable"></v-text-field>
												</v-col>
												<v-col cols="12" sm="6" >
													<v-text-field v-model="formulario[0].disposicion" outlined dense hide-details label="Dispoción"></v-text-field>
												</v-col>
												
												<v-col cols="12" sm="6">
													<v-textarea
													  v-model="formulario[0].descripConformidad"
					              		label="Descripción de la no conformidad"
					              		outlined
					              		dense
					              		rows="3"
														hide-details=""
					              	></v-textarea>
												</v-col>
												<v-col cols="12" sm="6">
													<v-textarea
													  v-model="formulario[0].descripcorrecion"
					              		label="Descripcion de la acción correctiva"
					              		outlined
					              		dense
					              		rows="3"
														hide-details=""
					              	></v-textarea>
												</v-col>
												<v-col cols="12" sm="6">
													<v-text-field v-model="formulario[0].fechaCompromiso" outlined dense hide-details type="date" label="Fecha de compromiso"></v-text-field>
												</v-col>
												<v-col cols="12" sm="6">
													<v-text-field v-model="formulario[0].veriFecha" outlined dense hide-details type="date" label="Fecha de validacion"></v-text-field>
												</v-col>
											</v-row>

											<v-card-actions class="mt-8">
												<v-spacer></v-spacer>
												<v-btn color="success" @click="guardarFormulario()"> Guardar Información</v-btn>
											</v-card-actions>

										</v-card>
									</v-dialog>


					        <v-dialog v-model="dialogDelete" max-width="500px">
					          <v-card>
					            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
					            <v-card-actions>
					              <v-spacer></v-spacer>
					              <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
					              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
					              <v-spacer></v-spacer>
					            </v-card-actions>
					          </v-card>
					        </v-dialog>

					      </v-toolbar>
					    </template>

					    <template v-slot:item.actions="{ item }">

					    	<v-tooltip bottom>
						      <template v-slot:activator="{ on, attrs }">
						        <v-btn
						          color="primary"
						          dark
						          v-bind="attrs"
						          v-on="on"
						          icon
						        >
						          <v-icon
								        small
								        @click="editItem(item)"
								      >
								        mdi-pencil
								      </v-icon>
						        </v-btn>
						      </template>
						      <span>Editar</span>
						    </v-tooltip>

						    <v-tooltip bottom>
						      <template v-slot:activator="{ on, attrs }">
						        <v-btn
						          color="primary"
						          dark
						          v-bind="attrs"
						          v-on="on"
						          icon
						        >
						          <v-icon
								        small
								        @click="vistaPrevia(item)"
								      >
								        mdi-eye
					      			</v-icon>
						        </v-btn>
						      </template>
						      <span>Vista previa</span>
						    </v-tooltip>
					    </template>
					    <template v-slot:no-data>
					      <v-btn
					        color="primary"
					        @click="initialize"
					      >
					        Reset
					      </v-btn>
					    </template>
					  </v-data-table>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <v-dialog
    	style="border-radius: 0px;"
      v-model="dialogFormato"
      max-width="1200"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="imprimir()"><v-icon>mdi-printer</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-container>
          	<div id="imprimir">
          		
	            <div class="app-wrapper">
					      <!-- Header section -->
					      <div class="header-container">
					        <img
					          alt="Mikai logo"
					          src="https://www.mikai.mx/wp-content/uploads/2017/08/Logotipo-Mikai.jpg"
					          class="header-img"
					        />

					        <h2>MIKAI, S.A. de C.V.</h2>

					        <div>
					          <h4>RC-CA-11</h4>
					          <h4>Rev. 0-05/21</h4>
					        </div>
					      </div>

					      <h3 class="report-name-label">
					        REPORTE DE NO CONFORMIDAD/ACCIÓN CORRECTIVA
					      </h3>

					      <!-- Header data section -->
					      <div class="header-container">
					        <div>
					          <h3>RESPONSABLE DEL PROYECTO</h3>
					          <p style="margin-top: 0.5rem">{{ responsable }}</p>
					        </div>

					        <div>
					          <h3>No. DE REPORTE:</h3>
					          <p style="margin-top: 0.5rem"> {{ noReporte }}</p>
					        </div>

					        <div>
					          <h3>FECHA</h3>
					          <p style="margin-top: 0.5rem">{{ fecha }}</p>
					        </div>
					      </div>

					      <h3 class="info-source-label">FUENTES DE INFORMACIÓN</h3>
					      <p>Proceso y/o Producto</p>

					      <!-- Information sources -->
					      <div class="info-sources-container">
					        <div>
					          <p class="info-sources-label">Servicio No Conforme</p>
					          <input type="checkbox" v-if="servicioNoConforme" checked />
					          <input type="checkbox" v-else/>
					        </div>
					        <div>
					          <p class="info-sources-label">Auditoria de Calidad</p>
					          <input type="checkbox" v-if="auditoriaCalidad" checked />
					          <input type="checkbox" v-else/>
					        </div>
					        <div>
					          <p class="info-sources-label">Queja del Cliente</p>
					          <input type="checkbox" v-if="quejaCliente" checked />
					          <input type="checkbox" v-else/>
					        </div>
					        <div>
					          <p class="info-sources-label">Satisfacción del Cliente</p>
					          <input type="checkbox" v-if="satisfaccionCliente" checked />
					          <input type="checkbox" v-else/>
					        </div>
					        <div>
					          <p class="info-sources-label">Sistema de Administración de Calidad</p>
					          <input type="checkbox" v-if="sistemaAdministracionCalidad" checked />
					          <input type="checkbox" v-else/>
					        </div>
					      </div>

					      <div class="intern-extern-options">
					        <label>Interna</label>
					        <input type="checkbox" class="intern-checkbox"  v-if="fuenteInformacion == 'Interna'" checked/>
					        <input type="checkbox" v-else class="intern-checkbox"/>
					        <label>Externa</label>
					        <input type="checkbox"  v-if="fuenteInformacion == 'Externa'" checked/>
					        <input type="checkbox" v-else/>
					      </div>

					      <!-- No conformity description -->
					      <div class="no-conformity-container">
					        <h3>Descripción de la No-Conformidad:</h3>
					        <br/>
					        {{ descripConformidad }}
					      </div>

					      <!-- Immediate action -->
					      <div class="immediate-action-container">
					        <div class="immediate-action-titles-container">
					          <h3>Disposición:</h3>
					          <h3>Acción inmediata consiste en:</h3>
					        </div>

					        <div>
					          <div class="immediate-action-option-container">
					            <h3 class="immediate-action-option-label">Correción</h3>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-if="correcion" checked/>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-else/>
					          </div>
					          <h3 class="immediate-action-option-description">
					            (Enfocado al SAC y al Servicio/Producto)
					          </h3>
					        </div>

					        <div>
					          <div class="immediate-action-option-container">
					            <h3 class="immediate-action-option-label">Reproceso</h3>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-if="reproceso" checked/>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-else/>
					          </div>
					          <h3 class="immediate-action-option-description">
					            (Enfocado al Servicio/Producto)
					          </h3>
					        </div>

					        <div>
					          <div class="immediate-action-option-container">
					            <h3 class="immediate-action-option-label">Rechazo</h3>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-if="rechazo" checked/>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-else/>
					          </div>
					          <h3 class="immediate-action-option-description">
					            (Enfocado al Servicio/Producto)
					          </h3>
					        </div>

					        <div>
					          <div class="immediate-action-option-container">
					            <h3 class="immediate-action-option-label">
					              Aceptado bajo concesión
					            </h3>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-if="aceptadoBajoConcesion" checked/>
					            <input class="immediate-action-option-checkbox" type="checkbox" v-else/>
					          </div>
					          <h3 class="immediate-action-option-description">
					            (Enfocado al Servicio/Producto)
					          </h3>
					        </div>
					      </div>

					      <!-- Corrective action -->
					      <div class="corrective-action-container">
					        <h3 class="corrective-action-title">
					          Evaluación para la aplicación de una Acción Correctiva
					        </h3>
					        <h3 class="corrective-conclusion-label">
					          Conclusión de la Evaluación:
					        </h3>
					        <br/>
					        {{ conclusionEvaluacion }}
					        <div class="corrective-flag-container">
					          <h3 class="corrective-flag-title">
					            Se requiere la Acción Correctiva:
					          </h3>
					          <div class="corrective-flag-option-true-container">
					            <label>Sí</label>
					            <input class="corrective-flag-checkbox" type="checkbox" v-if="seccioncuatro == 'si'" checked />
					            <input class="corrective-flag-checkbox" type="checkbox" />
					          </div>
					          <div>
					            <label>No</label>
					            <input class="corrective-flag-checkbox" type="checkbox" v-if="seccioncuatro == 'no'" checked/>
					            <input class="corrective-flag-checkbox" type="checkbox" />
					          </div>
					        </div>
					      </div>

					      <div style="display: grid; grid-template-columns: 1fr 1fr">
					        <h3>METODOLOGÍA: Análisis de Diagrama de Causa y Efecto</h3>
					        <h3>FECHA: {{ fechaMetodologia }} </h3>
					      </div>

					      <h3 class="metodology-label" style="margin-bottom: 1px;">MANO DE OBRA: </h3> {{ manoObra }}
					      <h3 class="metodology-label" style="margin-bottom: 1px;">MÉTODO:</h3> {{ metodo }}
					      <h3 class="metodology-label" style="margin-bottom: 1px;">MAQ. Y EQUIPO:</h3> {{ masYEquipo }}
					      <h3 class="metodology-label" style="margin-bottom: 1px;">MATERIALES:</h3> {{ materiales }}
					      <h3 class="metodology-label" style="margin-bottom: 1px;">MEDIO AMBIENTE:</h3> {{ medioAmbiente }}
					      <h3 class="metodology-label" style="margin-bottom: 1px;">PARTICIPANTES EN EL ANÁLISIS:</h3>

					      <div class="mt-1"><b>{{ participante1 }}</b></div>
					      <div class="mt-1"><b>{{ participante2 }}</b></div>
					      <div class="mt-1"><b>{{ participante3 }}</b></div>
					    </div>

					    <!-- Root cause description -->
					    <div class="root-cause-container">
					      <h3 class="root-cause-title">Descripción de la Causa Raíz:</h3> {{ descripCausaRaiz }}
					      <h3>Acción Correctiva: {{ accionCorrectiva }}</h3>
					    </div>

					    <!-- Person in charge signature -->
					    <div class="signature-container">
					      <div>
					        <h3 class="signature-label">FECHA DE COMPROMISO</h3>
					        {{ fechaCompromiso }}
					      </div>
					      <div>
					        <h3 class="signature-label">FIRMA DEL RESPONSABLE DEL PROCESO/ÁREA</h3>
					        _______________
					      </div>
					      <div>
					        <h3 class="signature-label">AUDITOR INTERNO DE CALIDAD</h3>
					        {{ auditorCalidad }}
					      </div>
					    </div>
					    <h3 class="followup-action-title">
					      SEGUIMIENTO DE ACCIÓN CORRECTIVA Y REVISIÓN DE SU IMPLEMENTACIÓN:
					    </h3>
					    <div class="follow-up-container">
					      <div>
					        <h3 class="signature-label">Evaluación de Avance %</h3>
					        <div>{{ seguimiento1por }}</div>
					        <div>{{ seguimiento2por }}</div>
					        <div>{{ seguimiento3por }}</div>
					        <div>{{ seguimiento4por }}</div>
					      </div>
					      <div>
					        <h3 class="signature-label">Fecha</h3>
					        <div>{{ seguimiento1Fecha }}</div>
					        <div>{{ seguimiento2Fecha }}</div>
					        <div>{{ seguimiento3Fecha }}</div>
					        <div>{{ seguimiento4Fecha }}</div>
					      </div>
					      <div>
					        <h3 class="signature-label">Fecha de Cumplimiento</h3>
					        {{ fechaCumplimientoRevision }}
					      </div>
					    </div>

					    <div class="intern-signature-container">
					      <div>
					        <h3 class="signature-label">Firma de Auditor Interno de Calidad</h3>
					        <p style="margin-right: 5rem">_______________</p>
					      </div>
					    </div>

					    <!-- Effectiveness verification -->
					    <h3 class="effectiveness-title">VERIFICACIÓN DE LA EFECTIVIDAD</h3>
					    <div class="effectiveness-container">
					      <div class="effectiveness-option-container">
					        <h3>¿ACCIÓN CORRECTIVA EFECTIVA?</h3>
					        <div>
					          <label>Sí</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriAccionCorrectiva == 'si'" checked />
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					          <label>No</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriAccionCorrectiva == 'no'" checked/>
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					        </div>
					      </div>
					      <h3 class="effectiveness-option-label">
					        EVIDENCIA OBJETIVA DE LA EFECTIVIDAD:
					      </h3>
					      <div><h3>FECHA: </h3>{{ veriFecha }}</div>

					      <div class="effectiveness-option-container">
					        <h3 class="effectiveness-option-label">
					          ¿SE REQUIERE ALGÚN CAMBIO EN LOS PROCEDIMIENTOS?
					        </h3>
					        <div>
					          <label>Sí</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriRquiereCambio == 'si'" checked />
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					          <label>No</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriRquiereCambio == 'no'" checked/>
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					        </div>
					      </div>
					      <div class="effectiveness-option-container">
					        <h3 class="effectiveness-option-label">
					          ¿SE REQUIERE LA RE-EVALUACIÓN DE LOS RIESGOS Y OPORTUNIDADES?
					        </h3>
					        <div>
					          <label>Sí</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriRevaluacion == 'si'" checked/>
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					          <label>No</label>
					          <input class="corrective-flag-checkbox" type="checkbox" v-if="veriRevaluacion == 'no'" checked/>
					          <input class="corrective-flag-checkbox" type="checkbox" v-else/>
					        </div>
					      </div>

					      <div class="audit-container">
					        <div>
					          <h3 class="signature-label" style="margin-bottom: 2px;">AUDITOR RESPONSABLE</h3>
					          <p>{{ veriAuditor }}</p>
					        </div>

					        <div class="auditory-close-container">
					          <h3>CIERRE DE AUDITORIA</h3>
					          <div>
					            <label>Sí</label>
					            <input class="corrective-flag-checkbox" type="checkbox" v-if="cierreAuditoria == 'si'" checked/>
					          	<input class="corrective-flag-checkbox" type="checkbox" v-else/>
					            <label>No</label>
					            <input class="corrective-flag-checkbox" type="checkbox" v-if="cierreAuditoria == 'no'" checked/>
					          	<input class="corrective-flag-checkbox" type="checkbox" v-else/>
					          </div>
					        </div>
					      </div>
					    </div>

					    <div class="report-details-container">
					      <div>
					        <h3>AC = ACCIÓN CORRECTIVA</h3>
					        <h3>SAC = SISTEMA DE ADMINISTRACIÓN DE CALIDAD</h3>
					      </div>
					      <div>
					        <h3 style="display: inline-block">Firma al finalizar:</h3>
					        <p style="display: inline-block">___________________</p>

					        <h3 class="iso-coordinator-label">Coordinador ISO</h3>
					      </div>
					    </div>
          	</div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            small
            @click="dialogFormato = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>

	import {mapActions , mapGetters} from 'vuex'


  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

			opciones_agregar:[
				 { id:1 , title: 'Llenar formato'    },
         { id:2 , title: 'Llenar formulario' },
			],
			formatoModal   : false,
			formularioModal: false,

			formulario: [{
					noReporte: '',
					fuenteInformacion: '',
					descripConformidad:'',
					responsable:'',
					disposicion: '',
					descripcorrecion:'',
					fechaCompromiso: '',
					veriFecha:''
			}],
			editFormulario:[
				{
					noReporte: '',
					fuenteInformacion: '',
					descripConformidad:'',
					responsable:'',
					protein: '',
					descripcorrecion:'',
					fechaCompromiso: '',
					veriFecha:''
				}
			],

    	idformato:0,
    	responsable:'',
			noReporte:0,
			fecha:null,

			consecutivo:'RC-CA-11-',

    	servicioNoConforme:          null,
			auditoriaCalidad:            null,
			quejaCliente:                null,
			satisfaccionCliente:         null,
			sistemaAdministracionCalidad:null,

			fuenteInformacion:null,

			descripConformidad:'',

			conclusionEvaluacion:'',

			correcion:null,
			reproceso:null,
			rechazo:null,
			aceptadoBajoConcesion:null,
			descripcorrecion:null,
			descripreproceso:null,
			descriprechazo:null,
			descripaceptadoBajoConcesion:null,

			fechaMetodologia:null,

			manoObra:'',
			metodo:'',
			masYEquipo:'',
			materiales:'',
			medioAmbiente:'',

			participante1:'',
			participante2:'',
			participante3:'',

			descripCausaRaiz:'',
			accionCorrectiva:'',

			fechaCompromiso:null,
			auditorCalidad:'',

			seguimiento1por:'',
			seguimiento1Fecha:null,
			seguimiento2por:'',
			seguimiento2Fecha:null,
			seguimiento3por:'',
			seguimiento3Fecha:null,
			seguimiento4por:'',
			seguimiento4Fecha:null,
			fechaCumplimientoRevision:null,

			veriAccionCorrectiva:null,
			veriEvidenciaObjetiva:'',
			veriFecha:null,
			veriRquiereCambio:null,
			veriRevaluacion:null,
			veriAuditor:'',
			cierreAuditoria:null,

			estatus:0,

    	fechaSeccion4:null,
    	seccioncuatro:null,
    	selected:[],
    	selected2:[],
    	descripConformidad:'',
    	dialogFormato:false,
      dialog: false,
      dialogDelete: false,
      estadoCA:'',  // IDENTIFICADO 
      tipoEstato: 0,

      readonly: true,
      readonlyAdmin:true,

      headers: [
        { text: 'No. Reporte', align: 'start', sortable: false, value: 'noReporte'},
        { text: 'Fuente de la No Conformidad'                 , value: 'fuenteInformacion' },
        { text: 'Descripción de la No Conformidad'            , value: 'descripConformidad' },
        { text: 'Area - Resp'                                 , value: 'responsable' },
        { text: 'Dispoción'                                   , value: 'disposicion' },
        { text: 'Descripción de la Acción correctiva'         , value: 'descripcorrecion' },
        { text: 'Fecha compromiso'                            , value: 'fechaCompromiso' },
        { text: 'Fecha de validación'                         , value: 'veriFecha' },
        { text: 'Estado (C/A)'                                , value: 'estadoCA' },
        { text: 'Acciones'                                    , value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      cargar:false,
    }),

    computed: {
      formTitle () {
        return 'Edición del formato'
      },

      ...mapGetters('login',['getdatosUsuario'])
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
    	console.log(this.getdatosUsuario)
    	if(this.getdatosUsuario.admin == 'ADMIN'){
    		this.readonly = true
    		this.readonlyAdmin = false
    	}else{
    		this.readonly = false
    		this.readonlyAdmin = true    		
    	}
      this.initialize()
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.desserts = []
        this.$http.get('formatos.all').then(response=>{
        	this.desserts = response.body
        	this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
			  this.idformato                     = item.idformato
			  this.responsable                   = item.responsable
			  this.noReporte                     = item.noReporte
			  this.consecutivo                   = item.consecutivo
			  this.fecha                         = item.fecha
			  this.servicioNoConforme            = item.servicioNoConforme
			  this.auditoriaCalidad              = item.auditoriaCalidad
			  this.quejaCliente                  = item.quejaCliente
			  this.satisfaccionCliente           = item.satisfaccionCliente
			  this.sistemaAdministracionCalidad  = item.sistemaAdministracionCalidad
			  this.fuenteInformacion             = item.fuenteInformacion
			  this.descripConformidad            = item.descripConformidad
			  this.conclusionEvaluacion          = item.conclusionEvaluacion
			  this.correcion                     = item.correcion
			  this.reproceso                     = item.reproceso
			  this.rechazo                       = item.rechazo
			  this.aceptadoBajoConcesion         = item.aceptadoBajoConcesion
			  this.descripcorrecion              = item.descripcorrecion
			  this.descripreproceso              = item.descripreproceso
			  this.descriprechazo                = item.descriprechazo
			  this.descripaceptadoBajoConcesion  = item.descripaceptadoBajoConcesion
			  this.fechaMetodologia              = item.fechaMetodologia
			  this.manoObra                      = item.manoObra
			  this.metodo                        = item.metodo
			  this.masYEquipo                    = item.masYEquipo
			  this.materiales                    = item.materiales
			  this.medioAmbiente                 = item.medioAmbiente
			  this.participante1                 = item.participante1
			  this.participante2                 = item.participante2
			  this.participante3                 = item.participante3
			  this.descripCausaRaiz              = item.descripCausaRaiz
			  this.accionCorrectiva              = item.accionCorrectiva
			  this.fechaCompromiso               = item.fechaCompromiso
			  this.auditorCalidad                = item.auditorCalidad
			  this.seguimiento1por               = item.seguimiento1por
			  this.seguimiento1Fecha             = item.seguimiento1Fecha
			  this.seguimiento2por               = item.seguimiento2por
			  this.seguimiento2Fecha             = item.seguimiento2Fecha
			  this.seguimiento3por               = item.seguimiento3por
			  this.seguimiento3Fecha             = item.seguimiento3Fecha
			  this.seguimiento4por               = item.seguimiento4por
			  this.seguimiento4Fecha             = item.seguimiento4Fecha
			  this.fechaCumplimientoRevision     = item.fechaCumplimientoRevision
			  this.veriAccionCorrectiva          = item.veriAccionCorrectiva
			  this.veriEvidenciaObjetiva         = item.veriEvidenciaObjetiva
			  this.veriFecha                     = item.veriFecha
			  this.veriRquiereCambio             = item.veriRquiereCambio
			  this.veriRevaluacion               = item.veriRevaluacion
			  this.veriAuditor                   = item.veriAuditor
			  this.cierreAuditoria               = item.cierreAuditoria
			  this.estatus                       = item.estatus
			  if(this.getdatosUsuario.admin == 'ADMIN'){
	    		this.estadoCA = 'A'
	    	}else{
	    		this.estadoCA = 'B'
	    	}
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.formatoModal = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.desserts.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.formatoModal = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      vistaPrevia (item) {
			  this.idformato                     = item.idformato
			  this.responsable                   = item.responsable
			  this.noReporte                     = item.noReporte
			  this.consecutivo                   = item.consecutivo
			  this.fecha                         = item.fecha
			  this.servicioNoConforme            = item.servicioNoConforme
			  this.auditoriaCalidad              = item.auditoriaCalidad
			  this.quejaCliente                  = item.quejaCliente
			  this.satisfaccionCliente           = item.satisfaccionCliente
			  this.sistemaAdministracionCalidad  = item.sistemaAdministracionCalidad
			  this.fuenteInformacion             = item.fuenteInformacion
			  this.descripConformidad            = item.descripConformidad
			  this.conclusionEvaluacion          = item.conclusionEvaluacion
			  this.correcion                     = item.correcion
			  this.reproceso                     = item.reproceso
			  this.rechazo                       = item.rechazo
			  this.aceptadoBajoConcesion         = item.aceptadoBajoConcesion
			  this.descripcorrecion              = item.descripcorrecion
			  this.descripreproceso              = item.descripreproceso
			  this.descriprechazo                = item.descriprechazo
			  this.descripaceptadoBajoConcesion  = item.descripaceptadoBajoConcesion
			  this.fechaMetodologia              = item.fechaMetodologia
			  this.manoObra                      = item.manoObra
			  this.metodo                        = item.metodo
			  this.masYEquipo                    = item.masYEquipo
			  this.materiales                    = item.materiales
			  this.medioAmbiente                 = item.medioAmbiente
			  this.participante1                 = item.participante1
			  this.participante2                 = item.participante2
			  this.participante3                 = item.participante3
			  this.descripCausaRaiz              = item.descripCausaRaiz
			  this.accionCorrectiva              = item.accionCorrectiva
			  this.fechaCompromiso               = item.fechaCompromiso
			  this.auditorCalidad                = item.auditorCalidad
			  this.seguimiento1por               = item.seguimiento1por
			  this.seguimiento1Fecha             = item.seguimiento1Fecha
			  this.seguimiento2por               = item.seguimiento2por
			  this.seguimiento2Fecha             = item.seguimiento2Fecha
			  this.seguimiento3por               = item.seguimiento3por
			  this.seguimiento3Fecha             = item.seguimiento3Fecha
			  this.seguimiento4por               = item.seguimiento4por
			  this.seguimiento4Fecha             = item.seguimiento4Fecha
			  this.fechaCumplimientoRevision     = item.fechaCumplimientoRevision
			  this.veriAccionCorrectiva          = item.veriAccionCorrectiva
			  this.veriEvidenciaObjetiva         = item.veriEvidenciaObjetiva
			  this.veriFecha                     = item.veriFecha
			  this.veriRquiereCambio             = item.veriRquiereCambio
			  this.veriRevaluacion               = item.veriRevaluacion
			  this.veriAuditor                   = item.veriAuditor
			  this.cierreAuditoria               = item.cierreAuditoria
			  this.estatus                       = item.estatus
        this.dialogFormato                 = true
        this.estadoCA                      = item.estadoCA
      },

      save () {
      	var payload =  {
				  idformato                     : this.idformato,
				  responsable                   : this.responsable,
				  noReporte                     : this.noReporte,
				  consecutivo                   : this.consecutivo,
				  fecha                         : this.fecha,
				  servicioNoConforme            : this.servicioNoConforme,
				  auditoriaCalidad              : this.auditoriaCalidad,
				  quejaCliente                  : this.quejaCliente,
				  satisfaccionCliente           : this.satisfaccionCliente,
				  sistemaAdministracionCalidad  : this.sistemaAdministracionCalidad,
				  fuenteInformacion             : this.fuenteInformacion,
				  descripConformidad            : this.descripConformidad,
				  conclusionEvaluacion          : this.conclusionEvaluacion,
				  correcion                     : this.correcion,
				  reproceso                     : this.reproceso,
				  rechazo                       : this.rechazo,
				  aceptadoBajoConcesion         : this.aceptadoBajoConcesion,
				  descripcorrecion              : this.descripcorrecion,
				  descripreproceso              : this.descripreproceso,
				  descriprechazo                : this.descriprechazo,
				  descripaceptadoBajoConcesion  : this.descripaceptadoBajoConcesion,
				  fechaMetodologia              : this.fechaMetodologia,
				  manoObra                      : this.manoObra,
				  metodo                        : this.metodo,
				  masYEquipo                    : this.masYEquipo,
				  materiales                    : this.materiales,
				  medioAmbiente                 : this.medioAmbiente,
				  participante1                 : this.participante1,
				  participante2                 : this.participante2,
				  participante3                 : this.participante3,
				  descripCausaRaiz              : this.descripCausaRaiz,
				  accionCorrectiva              : this.accionCorrectiva,
				  fechaCompromiso               : this.fechaCompromiso,
				  auditorCalidad                : this.auditorCalidad,
				  seguimiento1por               : this.seguimiento1por,
				  seguimiento1Fecha             : this.seguimiento1Fecha,
				  seguimiento2por               : this.seguimiento2por,
				  seguimiento2Fecha             : this.seguimiento2Fecha,
				  seguimiento3por               : this.seguimiento3por,
				  seguimiento3Fecha             : this.seguimiento3Fecha,
				  seguimiento4por               : this.seguimiento4por,
				  seguimiento4Fecha             : this.seguimiento4Fecha,
				  fechaCumplimientoRevision     : this.fechaCumplimientoRevision,
				  veriAccionCorrectiva          : this.veriAccionCorrectiva,
				  veriEvidenciaObjetiva         : this.veriEvidenciaObjetiva,
				  veriFecha                     : this.veriFecha,
				  veriRquiereCambio             : this.veriRquiereCambio,
				  veriRevaluacion               : this.veriRevaluacion,
				  veriAuditor                   : this.veriAuditor,
				  cierreAuditoria               : this.cierreAuditoria,
				  estatus                       : this.estatus,
				  estadoCA                      : this.estadoCA
				}

        if (this.editedIndex > -1) {
        	payload.estatus = 1
          this.$http.put('formatos.update/' + this.idformato, payload).then(response=>{
	          this.initialize()
          }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
        } else {
          this.$http.post('formatos.add', payload).then(response=>{
          	var update = {
          		idformato:   response.body.id,
          		consecutivo: this.consecutivo + response.body.id.toString().padStart(4,"0")
          	}
          	this.$http.put('formatos.update.consecutivo/' + update.idformato ,update).then(response=>{
	          	this.initialize()
	          }).catch( error =>{
		          this.validarError( error )
		        }).finally( () => { this.cargar = false })
          }).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
        }
        this.close()
      },

      imprimir () {
      	var contenido           = document.getElementById('imprimir').innerHTML;
		    var contenidoOriginal   = document.body.innerHTML;
		    document.body.innerHTML = contenido;
		    window.print();
		    document.body.innerHTML = contenidoOriginal;

		    location.reload()
      },

      abrirDialogFormato () {
      	this.dialogFormato = true
      },

			guardarFormulario(){
				this.$http.post('agregar.nuevo.formulario', this.formulario[0]).then(response=>{
					const update = new Object({
						idformato:   response.body.id,
						consecutivo: this.consecutivo + response.body.id.toString().padStart(4,"0")
					});

					this.$http.put('formatos.update.consecutivo/' + update.idformato ,update).then(response=>{
						this.formularioModal = false;
						this.initialize(); 
					}).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
				}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })



			}
    },

  }
</script>
<style scoped>
  /* ----- App wrapper ----- */
  .app-wrapper {
    margin: 1rem;
  }

  /* ----- Header ----- */
  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 1rem;
  }
  .header-container:first-child > div,
  .header-container,
  .report-name-label,
  .intern-extern-options,
  .corrective-action-title {
    text-align: center;
  }
  .header-container,
  .no-conformity-container {
    border: 1px solid black;
  }
  .header-img {
    width: 150px;
  }

  .report-name-label {
    margin: 1rem 0;
  }
  .info-source-label {
    margin-bottom: 0.5rem;
  }

  /* ----- Information resources ----- */
  .info-sources-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 1rem 1rem;
    text-align: center;
  }
  .info-sources-label {
    margin-bottom: 1rem;
  }
  .intern-checkbox {
    margin-right: 1rem;
  }

  /* ----- No conformity description ----- */
  .no-conformity-container {
    padding: 0.5rem 0.5rem 1.5rem 0.5rem;
    margin: 1rem 0;
  }

  /* ----- Immediate action ----- */
  .immediate-action-container {
    border: 1px solid black;
    padding: 0.5rem;
    margin: 1rem 0;
  }
  .immediate-action-titles-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .immediate-action-option-container {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
  }
  .immediate-action-option-label,
  .immediate-action-option-checkbox {
    margin-right: 1rem;
  }
  .immediate-action-option-description {
    font-weight: normal;
  }

  /* ----- Corrective action ----- */
  .corrective-action-container {
    border: 1px solid black;
    padding: 0.5rem;
    margin: 1rem 0;
  }
  .corrective-conclusion-label {
    margin: 1rem 0;
  }
  .corrective-flag-container {
    display: flex;
    align-items: center;
  }
  .corrective-flag-title {
    margin-right: 1rem;
  }
  .corrective-flag-option-true-container {
    margin-right: 1rem;
  }
  .corrective-flag-checkbox {
    margin: 0 0.5rem;
  }
  .metodology-label {
    margin: 1rem 0;
  }

  /* ----- Root cause description ----- */
  .root-cause-container {
    border: 1px solid black;
    margin: 1rem;
    padding: 0.5rem;
  }
  .root-cause-title {
    margin-bottom: 1rem;
  }

  /* ----- Person in charge signature ----- */
  .signature-container {
    border: 1px solid black;
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    margin: 1rem;
    padding: 0.5rem;
  }
  .signature-label {
    margin-bottom: 3rem;
  }
  .followup-action-title {
    text-align: center;
    margin: 1rem;
  }
  .follow-up-container {
    text-align: center;
    display: flex;
    justify-content: space-evenly;
    margin: 1rem 0 2rem 0;
  }
  .intern-signature-container {
    margin: 1rem;
    text-align: right;
  }

  /* ----- Effectiveness ----- */
  .effectiveness-title {
    text-align: center;
    margin: 3rem 0 1rem 0;
  }
  .effectiveness-container {
    border: 1px solid black;
    margin: 1rem 1rem 3rem 1rem;
    padding: 0.5rem;
  }
  .effectiveness-option-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .effectiveness-option-label {
    margin: 1rem 0;
  }
  .audit-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .auditory-close-container {
    display: flex;
    margin-bottom: 5rem;
  }
  .auditory-close-container > h3 {
    margin-right: 1rem;
  }

  /* ----- Report details ----- */
  .report-details-container {
    margin: 1rem;
    display: grid;
    grid-template-columns: 2fr 1fr;
  }
  .iso-coordinator-label {
    margin-left: 5rem;
  }

.v-dialog .v-dialog--active::-webkit-scrollbar {
    width: 8px;     /* Tamaño del scroll en vertical */
    height: 8px;    /* Tamaño del scroll en horizontal */
    display: none;  /* Ocultar scroll */
}


/* Ponemos un color de fondo y redondeamos las esquinas del thumb */
.v-dialog .v-dialog--active::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
}

/* Cambiamos el fondo y agregamos una sombra cuando esté en hover */
.v-dialog .v-dialog--active::-webkit-scrollbar-thumb:hover {
    background: #b3b3b3;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

/* Cambiamos el fondo cuando esté en active */
.v-dialog .v-dialog--active::-webkit-scrollbar-thumb:active {
    background-color: #999999;
}

</style>
